import { VectorSquareRemoveIcon } from './VectorSquareRemoveIcon';

/**
 * author: Andrea Antonello
 * id 453AE0C4-2846-4EF0-AD04-D3981FC002A0
 * name vector-square-remove
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-square-remove.svg
 * tags
 * - Vector 
 */
export const VectorSquareDeleteIcon = VectorSquareRemoveIcon;
export default VectorSquareDeleteIcon